import { useLocation, useNavigate } from "react-router";
import { PaperPlane, Person, Persons, TargetDart } from "@gravity-ui/icons";
import { useAuthContext } from "@/context/useAuthContext";
import { RoutesList } from "@/router/routesList";
export var useNavigationData = function () {
    var isProfileComplete = useAuthContext().isProfileComplete;
    var navigate = useNavigate();
    var location = useLocation();
    var itemClickHandler = function (itemData, route) {
        if (isProfileComplete) {
            navigate(route);
        }
    };
    var checkRoute = function (startPath) {
        return (location === null || location === void 0 ? void 0 : location.pathname.indexOf(startPath)) === 0;
    };
    var navigationItems = [
        {
            id: "places",
            title: "Площадки",
            current: checkRoute(RoutesList.Place.getPlacesList()),
            onItemClick: function (item) {
                return itemClickHandler(item, RoutesList.Place.getPlacesList());
            },
            icon: TargetDart,
        },
        {
            id: "games",
            title: "Игры",
            current: checkRoute(RoutesList.Game.getGamesList()),
            onItemClick: function (item) {
                return itemClickHandler(item, RoutesList.Game.getGamesList());
            },
            icon: PaperPlane,
        },
        {
            id: "users",
            title: "Пользователи",
            current: checkRoute(RoutesList.Users.getUsersList()),
            onItemClick: function (item) {
                return itemClickHandler(item, RoutesList.Users.getUsersList());
            },
            icon: Persons,
        },
        {
            id: "profile",
            title: "Профиль",
            current: checkRoute(RoutesList.Profile.getUserProfile()),
            onItemClick: function (item) {
                return itemClickHandler(item, RoutesList.Profile.getUserProfile());
            },
            icon: Person,
        },
    ];
    return {
        navigationItems: navigationItems,
    };
};
